import {
  ColumnLayout,
} from '@cloudscape-design/components';
import PropTypes from 'prop-types';
import React from 'react';

import PLCFields from './plcFields';

function PIDControls({
  fieldsBySide,
  upperTitle = 'Upper',
  lowerTitle = 'Lower',
  fieldColumns = 1,
}) {
  return (
    <ColumnLayout columns={2} variant="text-grid">
      <PLCFields
        title={upperTitle}
        fields={fieldsBySide.upper}
        fieldColumns={fieldColumns}
      />
      <PLCFields
        title={lowerTitle}
        fields={fieldsBySide.lower}
        fieldColumns={fieldColumns}
      />
    </ColumnLayout>
  );
}

PIDControls.propTypes = {
  fieldsBySide: PropTypes.shape({
    upper: PLCFields.propTypes.fields,
    lower: PLCFields.propTypes.fields,
  }).isRequired,
  upperTitle: PropTypes.string,
  lowerTitle: PropTypes.string,
  fieldColumns: PropTypes.number,
};

export default PIDControls;
